import { Address, AddressInput } from '@varo/graphql-schema-types';

const areAddressesIdentical = (
  address1: AddressInput | Address | null | undefined,
  address2: AddressInput | Address | null | undefined,
): boolean => {
  if (!address1 || !address2) {
    return false;
  }

  const normalizeStrict = (value: string | null | undefined): string =>
    (value ?? '').trim().toLowerCase();

  const normalizeLine2 = (value: string | null | undefined): string =>
    value === null || value === undefined ? '' : value.trim().toLowerCase();

  return (
    normalizeStrict(address1.addressLine1) ===
      normalizeStrict(address2.addressLine1) &&
    normalizeLine2(address1.addressLine2) ===
      normalizeLine2(address2.addressLine2) &&
    normalizeStrict(address1.city) === normalizeStrict(address2.city) &&
    normalizeStrict(address1.state) === normalizeStrict(address2.state) &&
    normalizeStrict(address1.zip) === normalizeStrict(address2.zip) &&
    normalizeStrict(address1.country) === normalizeStrict(address2.country)
  );
};

export default areAddressesIdentical;
